import React from 'react'
import { Consumer } from '../../context';
import { Link } from 'react-router-dom';
import {v4 as uuid} from 'uuid'
import BlogCardDark from '../Cards/BlogCardDark';

function BlogSection() {
    return (
        <Consumer>
            {(value) => {
                const {blogs} = value;
                return (
                    <div>
                        <div className="container-fluid lightSection">
                            <div className="container">
                                <div className="display-5 text-center pt-5 pb-3">
                                    B l o g s
                                </div>
                                <div className="row pb-3 px-5 font-monospace justify-content-center">
                                    {blogs.slice(0,2).map((blg) => (
                                        <div key={uuid()} className="col-12 col-md-6 col-lg-4 py-lg-5 py-3">
                                            <BlogCardDark
                                                //section={blogs}
                                                blog={blg} />
                                        </div>
                                    ))}
                                </div>
                                <div className="pb-3">
                                    <Link to="/blogs" className="sectionlink">
                                        <h5 className="text-end pe-5 font-monospace">
                                            View all <i className="fas fa-arrow-right align-middle"></i>
                                        </h5>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Consumer>
    )
}

export default BlogSection;